var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18L20.1214 16.829C19.6134 16.1258 18.7101 15.8301 17.8847 16.097C17.0592 16.3639 16.5 17.1325 16.5 18H18.5ZM30.5 56C16.1406 56 4.5 44.3596 4.5 30H0.5C0.5 46.5684 13.9314 60 30.5 60V56ZM56.5 30C56.5 44.3596 44.8596 56 30.5 56V60C47.0684 60 60.5 46.5684 60.5 30H56.5ZM30.5 4C44.8596 4 56.5 15.6406 56.5 30H60.5C60.5 13.4314 47.0684 0 30.5 0V4ZM30.5 0C13.9314 0 0.5 13.4314 0.5 30H4.5C4.5 15.6406 16.1406 4 30.5 4V0ZM20.5 48V18H16.5V48H20.5ZM16.8786 19.171L42.8788 55.1708L46.1212 52.8292L20.1214 16.829L16.8786 19.171ZM40.5 16V40H44.5V16H40.5Z",
    fill: "url(#paint0_linear_1159_2547)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2547",
    x1: 0.5,
    y1: 30,
    x2: 60.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_2547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.555669ac98ba8991165ac34b2364ef2b.svg";
export { ForwardRef as ReactComponent };